export type Outlook = 'Good' | 'Cautionary' | 'Concerning' | 'Indeterminate' | null;
export class OutlookInfo {
	constructor(
		public outlook: Outlook,
		public annotation?: string | null,
	) {}
}
